var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<debug-definitions-node params="definitions: $data, node: $data._defs"></debug-definitions-node>';
}
return __p;
};
